import { createFileRoute, redirect } from "@tanstack/react-router";
import { Inbox } from "lucide-react";
import { Button, EmptyState } from "../components/ui";
import { AuthLayout } from "../features/auth/auth-layout";
import { requireUser } from "../features/auth/guards";
import { useSignOut } from "../features/auth/use-sign-out";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const me = await requireUser(context, "/");
    const first = me.workspaces[0];
    if (first) throw redirect({ to: "/w/$slug", params: { slug: first.slug } });
    return { me };
  },
  component: NoWorkspace,
});

function NoWorkspace() {
  const { me } = Route.useRouteContext();
  const signOut = useSignOut();
  return (
    <AuthLayout title={`Hi ${me.user.name}`}>
      <EmptyState
        icon={<Inbox className="size-8" />}
        title="You're not in any workspace yet"
        description="Ask your agency to invite you. The invitation email has a link that brings you straight in."
        action={
          <Button variant="secondary" onClick={() => void signOut()}>
            Sign out
          </Button>
        }
      />
    </AuthLayout>
  );
}
